import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const RequestDetailsCard = styled(CustomCard)`
  .ant-descriptions-item {
    padding-bottom: 4px;

    .ant-descriptions-item-content {
      font-size: 1rem;
    }
  }
`;

export const RequestDetailsTypes = styled.div`
  margin-bottom: 16px;
`;
